module.exports = __webpack_public_path__ + "img/s3-2.96e0f10c.jpg";